<template>
    <div class="wrapper">
        <div class="content">
            <h2 class="page_title">{{ $t("page.apix_drive.title") }}</h2>

            <div class="settings">
                <button
                    @click="isActive = !isActive"
                    :class="[
                        'button_source',
                        { 'active-button': buttonSource },
                    ]"
                >
                    {{ $t("page.apix_drive.button_source") }}
                </button>
                <button
                    @click="isActive = !isActive"
                    :class="[
                        'button_reception',
                        { 'active-button': buttonReception },
                    ]"
                >
                    {{ $t("page.apix_drive.button_reception") }}
                </button>
            </div>

            <transition name="fade">
                <apix-drive-source-tab-instruction v-if="buttonSource" />

                <apix-drive-data-tab-instruction v-else-if="buttonReception" />
            </transition>
        </div>
    </div>
</template>

<script>
import ApixDriveSourceTabInstruction from "@/components/Instruction/ApixDriveSourceTabInstruction.vue";
import ApixDriveDataTabInstruction from "@/components/Instruction/ApixDriveDataTabInstruction.vue";

export default {
    components: {
        ApixDriveSourceTabInstruction,
        ApixDriveDataTabInstruction,
    },

    data() {
        return {
            windowSize: 0,
            buttonSource: true,
            buttonReception: false,
            isActive: false,
        };
    },

    watch: {
        isActive() {
            this.buttonSource = !this.buttonSource;
            this.buttonReception = !this.buttonReception;
        },
    },

    methods: {
        onResize() {
            this.windowSize = window.innerWidth;
        },
    },

    created() {
        window.addEventListener("resize", this.onResize);
        this.onResize();
    },
};
</script>

<style lang="scss" scoped>
@use "@/styles/pages/instruction.scss";

.settings {
    margin: 30px 0 40px;

    display: flex;
    align-items: center;
    gap: 16px;

    button {
        cursor: pointer;

        width: 300px;
        height: 60px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-family: "Gilroy";
        font-size: 16px;
        font-weight: 500;

        text-transform: uppercase;

        color: white;

        box-sizing: border-box;
        border: none;
        border-radius: 11px;

        &:hover {
            cursor: pointer;
        }

        &.button_source {
            background-color: var(--block-color);

            color: rgba(#000000, 0.52);

            &.active-button {
                background-color: #7a70df;

                color: white;
            }
        }

        &.button_reception {
            background-color: var(--block-color);

            color: rgba(#000000, 0.52);

            &.active-button {
                background-color: #7a70df;

                color: white;
            }
        }
    }
}
</style>
